angular.module("app").controller("ProvidersEditPageController", [
    '$scope',
    'preloadedData',
    'casinoProviderService',
    'errorHandler',
    'logger',
    'pageStatuses',
    'deepCompare',
    function ($scope, preloadedData, casinoProviderService, errorHandler, logger, pageStatuses, deepCompare) {
        $scope.tooltip = {
            name: "",
            title: ""
        };

        $scope.pageStatuses = pageStatuses;

        $scope.save = function () {
            var requestData = {
                    casinoProvider: {}
                },
                changes;

            changes = deepCompare.getChanges(preloadedData.provider, fetchData());
            changes.name = preloadedData.provider.name;
            requestData.casinoProvider = changes;
            casinoProviderService.edit(requestData).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("updated");
                        preloadedData.provider = fetchData();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.isAllowedToUpdate = function () {
            return deepCompare.isEqual(fetchData(), preloadedData.provider)
        };

        function init () {
            $scope.providerData = angular.copy(preloadedData.provider);

            $scope.edit_providers_form && $scope.edit_providers_form.$setPristine();
        }

        function fetchData () {
            return angular.copy($scope.providerData);
        }

        init();

    }
]);